import React from 'react';

import { SvgUse } from 'src/shoppe/elements/SvgUse';

import styles from './index.module.sass';

export const NewBadge = () => (
  <SvgUse ariaLabel="New" className={`${styles.badge} mb-1 mb-md-2`} name="new-badge" />
);
